
import React from "react";
import GoToMarket from '../Components/Dashboard/Product-Portfolio/GoToMarket';
import SessionTimeoutRedirect from '../Components/Common/SessionTimeoutRedirect'
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
const AuthGoToMarket = () => {
   const useAuth=()=>{
    const user=localStorage.getItem('user_id')
    const token = document.cookie.replace(/(?:(?:^|.*;\s*)token\s*=\s*([^;]*).*$)|^.*$/, '$1');

    if(token){
      return true
    } else {
      localStorage.clear()
      return false
    }
  }
  const auth = useAuth();
  return auth ? <GoToMarket /> : <SessionTimeoutRedirect />
}
export default AuthGoToMarket;


